/** Pre-written social copy for viral share cards. */

export interface ShareCaptionInput {
    leagueName: string;
    teamName: string;
    countyName?: string;
    stateName?: string;
    landShare?: number;
    rivalName?: string;
    hook?: 'county' | 'rivalry' | 'swing' | 'hero' | 'fantasy' | 'legends';
}

export function buildShareCaption(input: ShareCaptionInput): { title: string; text: string; hashtags: string } {
    const place = input.countyName && input.stateName
        ? `${input.countyName}, ${input.stateName}`
        : input.countyName || 'my county';
    const pct = input.landShare != null ? `${Math.round(input.landShare * 100)}%` : null;

    switch (input.hook) {
        case 'swing':
            return {
                title: `${input.teamName} flipped ${input.countyName || 'the map'}`,
                text: input.rivalName
                    ? `${input.teamName} took ${input.countyName || 'counties'} from ${input.rivalName} on the ${input.leagueName} empire map.`
                    : `${input.teamName} made the biggest land swing this week on Empire Maps.`,
                hashtags: '#ImperialismMap #EmpireMaps',
            };
        case 'rivalry':
            return {
                title: `${input.teamName} vs ${input.rivalName || 'the rival'} — Empire Maps`,
                text: pct
                    ? `${input.teamName} controls ${pct} of the ${input.leagueName} map on Empire Maps.`
                    : `${input.teamName} on the ${input.leagueName} conquest map — Empire Maps.`,
                hashtags: '#ImperialismMap #CollegeBasketball #EmpireMaps',
            };
        case 'legends':
            return {
                title: input.rivalName
                    ? `All-Time ${input.teamName} vs ${input.rivalName} — Legends Sim`
                    : `All-Time ${input.teamName} — Legends Sim`,
                text: input.rivalName
                    ? `Legends across every era: All-Time ${input.teamName} vs All-Time ${input.rivalName}. Who wins YOUR dream superteam matchup?`
                    : `Stack decades of ${input.teamName} legends into one roster and sim the exhibition at EmpireMaps.live`,
                hashtags: '#AllTimeEmpire #Legends #CollegeBasketball #EmpireMaps',
            };
        case 'hero':
            return {
                title: `Hero highlights — ${input.leagueName}`,
                text: input.rivalName
                    ? `Last night's top heroes on the ${input.leagueName} player empire map: ${input.rivalName}`
                    : `See who dominated the ${input.leagueName} hero map this week on Empire Maps.`,
                hashtags: '#HeroMap #EmpireMaps #ImperialismMap',
            };
        case 'fantasy':
            return {
                title: `${input.teamName} leads the fantasy war`,
                text: pct
                    ? `${input.teamName} scored big this week and controls ${pct} of the ${input.leagueName} fantasy empire map.`
                    : `${input.teamName} is this week's fantasy war leader on Empire Maps.`,
                hashtags: '#FantasyFootball #EmpireMaps #ImperialismMap',
            };
        case 'county':
        default:
            return {
                title: `${input.teamName} owns ${place}`,
                text: `According to the ${input.leagueName} imperialism map, ${place} belongs to ${input.teamName}. Check yours at EmpireMaps.live`,
                hashtags: '#ImperialismMap #EmpireMaps',
            };
    }
}

export function captionWithHashtags(caption: { text: string; hashtags: string }): string {
    return `${caption.text} ${caption.hashtags}`.trim();
}
